import type { CreateTrainingSessionRequest, TrainingSession, UpdateTrainingSessionRequest } from "../types";
import type { TranscriptContent } from "./evaluations/types";
import { getTrainingSessionApiClient } from "./trainingSessionApi";

interface TrainingSessionApiResult {
    count: number;
    items: TrainingSession[];
}

interface EvaluationByIdApiResult {
    count: number;
    items: TranscriptContent[];
}

export const createTrainingSession = async (request: CreateTrainingSessionRequest) => {
    await getTrainingSessionApiClient().post("create", {
        json: request,
    });
};

export const updateTrainingSession = async (request: UpdateTrainingSessionRequest) => {
    await getTrainingSessionApiClient().post("update", {
        json: request,
    });
};

export const getTrainingSessionsByEmployeeId = async (
    employeeId: string | null,
    challengeId?: string,
    sessionId?: string,
): Promise<TrainingSessionApiResult> => {
    const response = await getTrainingSessionApiClient().post("query", {
        json: {
            EmployeeId: employeeId,
            ChallengeId: challengeId,
            SessionId: sessionId,
        },
    });
    const trainingSessions = await response.json<TrainingSessionApiResult>();

    return trainingSessions;
};

export const getEvaluationResultsBySessionId = async (sessionId: string): Promise<EvaluationByIdApiResult> => {
    const response = await getTrainingSessionApiClient().post("query", {
        json: {
            SessionId: sessionId,
        },
    });
    const trainingSession = await response.json<EvaluationByIdApiResult>();
    return trainingSession;
};
